<template>
    <div
        v-if="isShowErrorMsg"
        class="console-btn error-msg-service"
        @click="showMsg"
    >
        <svg-icon
            icon-name="info-circle-regular"
            :width="20"
            :height="20"
            color="#eca806"
        ></svg-icon>
    </div>
</template>

<script setup lang="ts">
    import { onBeforeUnmount, onMounted, ref } from 'vue';
    import SvgIcon from '@/components/base/SvgIcon.vue';

    interface ErrorStatusChangedPayload {
        isShow: boolean;
        errorMsg?: string;
    }

    type LegacyEventPayload =
        | ErrorStatusChangedPayload
        | string
        | number
        | boolean
        | null
        | undefined;

    interface LegacyEventBus {
        $emit: (eventName: string, payload?: LegacyEventPayload) => void;
        $on: (
            eventName: string,
            callback: (payload: ErrorStatusChangedPayload) => void
        ) => void;
        $off: (
            eventName: string,
            callback?: (payload: ErrorStatusChangedPayload) => void
        ) => void;
    }

    // ----- state -----
    const isShowErrorMsg = ref(false);

    const getLegacyEventBus = (): LegacyEventBus | null => {
        const windowBus = (window as Window & { eventBus?: LegacyEventBus })
            .eventBus;
        if (windowBus) {
            return windowBus;
        }

        const globalBus = (globalThis as { eventBus?: LegacyEventBus })
            .eventBus;
        return globalBus ?? null;
    };

    const onErrorStatusChanged = (payload: ErrorStatusChangedPayload): void => {
        isShowErrorMsg.value = Boolean(payload.isShow);
    };

    // ----- methods -----
    // 重新顯示錯誤訊息
    const showMsg = (): void => {
        const bus = getLegacyEventBus();
        bus?.$emit('reshowErrorMsg');
    };

    onMounted(() => {
        const bus = getLegacyEventBus();
        bus?.$on('errorStatusChanged', onErrorStatusChanged);
    });

    onBeforeUnmount(() => {
        const bus = getLegacyEventBus();
        bus?.$off('errorStatusChanged', onErrorStatusChanged);
    });
</script>

<style scoped lang="scss">
    .console-btn.error-msg-service {
        display: flex;
        position: relative;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        padding: 4px 8px;
        background-color: #ffffff;
        border: 1px solid $grayColorE7;
        cursor: pointer;

        &:hover {
            background-color: #fffdeb;
        }

        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            right: 0;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #fc8f00;
        }
    }
</style>
